// extracted by mini-css-extract-plugin
export var createdDate = "_l4-1";
export var divider = "_l4-2";
export var headerDivider = "_l4-3";
export var messagesCard = "_l4-0";
export var messagesContainer = "_l4-6";
export var messagesContainerWrapper = "_l4-4";
export var showLeftPanelButton = "_l4-8";
export var topButtons = "_l4-7";
export var withPadding = "_l4-5";